import { App } from 'vue';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default function config(app: App): void {
    app.component('VueDatePicker', VueDatePicker);
}
